import { getHttpClient } from "@/http-client";

const baseUrl = "api/boss/webhooks";
export const unsubscribe = id => {
  return getHttpClient().delete(`${baseUrl}/${id}`);
};
export const update = (id, webhook) => {
  return getHttpClient().put(`${baseUrl}/${id}`, { webhook });
};
